var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReminder = function SvgReminder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5732 10.8904C16.5732 14.437 13.6635 17.3388 10.0411 17.3388C6.41869 17.3388 3.50903 14.437 3.50903 10.8904C3.50903 7.34383 6.41869 4.44202 10.0411 4.44202C13.6635 4.44202 16.5732 7.34383 16.5732 10.8904Z",
    fill: "white",
    stroke: "#9CA4B5",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69687 7.27266C10.0119 7.27266 10.2708 7.4837 10.3001 7.75355L10.3029 7.8048V9.84609L12.5496 11.8187C12.7715 12.0135 12.7854 12.3218 12.5912 12.5308L12.5496 12.5712C12.3277 12.7661 11.9766 12.7782 11.7385 12.6078L11.6925 12.5712L9.26833 10.4427C9.16888 10.3554 9.10756 10.2408 9.09379 10.119L9.09082 10.0664V7.8048C9.09082 7.51091 9.36216 7.27266 9.69687 7.27266Z",
    fill: "#9CA4B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75368 1.98162C4.77051 0.90108 3.10066 0.813572 2.00994 1.78543C0.903043 2.77171 0.81395 4.47178 1.8117 5.56835L2.015 5.79179L5.99433 2.24611L5.75368 1.98162Z",
    fill: "#9CA4B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2458 1.98162C15.229 0.90108 16.8988 0.813572 17.9896 1.78543C19.0965 2.77171 19.1856 4.47178 18.1878 5.56835L17.9845 5.79179L14.0052 2.24611L14.2458 1.98162Z",
    fill: "#9CA4B5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReminder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reminder.dc358f68.svg";
export { ForwardRef as ReactComponent };